import * as i0 from '@angular/core';
import { Pipe, EventEmitter, forwardRef, Component, Input, Output, ViewChild, HostBinding, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

// this pipe replaces html entity '&shy;', '&#173;' aka. "soft hyphen" with the actual character, so line-breaks can be displayed in a predictable way
// we're not using ng-content here, so this pipe is needed.
// should be no XSS sinks here, as we're only replacing a specific html entity, we're not parsing the string into HTML.
const _c0 = ["ref"];
const _c1 = (a0, a1, a2) => ({
  selected: a0,
  rebrand: a1,
  disabled: a2
});
function ChipComponent_div_2_i_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const chip_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("icon-xsmall", !ctx_r2.rebrand)("selected", ctx_r2.rebrand && chip_r2.selected)("pin", ctx_r2.rebrand)("chipIcon", ctx_r2.rebrand)("iconLeft", ctx_r2.rebrand);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.iconName, " ");
  }
}
function ChipComponent_div_2_i_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 8);
    i0.ɵɵtext(1, "check");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const chip_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("selected", ctx_r2.rebrand && chip_r2.selected)("icon-xsmall", !ctx_r2.rebrand)("chipIcon", ctx_r2.rebrand)("iconLeft", ctx_r2.rebrand);
  }
}
function ChipComponent_div_2_i_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 7);
    i0.ɵɵtext(1, "remove_circle_filled");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const chip_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("selected", chip_r2.selected && ctx_r2.rebrand)("icon-xsmall", !ctx_r2.rebrand)("chipIcon", ctx_r2.rebrand)("iconRight", ctx_r2.rebrand);
  }
}
function ChipComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵlistener("keydown", function ChipComponent_div_2_Template_div_keydown_0_listener($event) {
      const chip_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.chipKeydown($event, chip_r2));
    })("click", function ChipComponent_div_2_Template_div_click_0_listener($event) {
      const chip_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.chipClick($event, chip_r2));
    });
    i0.ɵɵtemplate(1, ChipComponent_div_2_i_1_Template, 2, 11, "i", 4)(2, ChipComponent_div_2_i_2_Template, 2, 8, "i", 5);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "unescape");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, ChipComponent_div_2_i_6_Template, 2, 8, "i", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const chip_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("chipBase", ctx_r2.rebrand)("chip", ctx_r2.rebrand);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(17, _c1, chip_r2.selected, ctx_r2.rebrand, chip_r2.disabled));
    i0.ɵɵattribute("tabindex", chip_r2.disabled ? null : 0)("id", chip_r2.id ? chip_r2.id : null)("role", ctx_r2.chipType === "choice" ? "radio" : "checkbox")("aria-checked", chip_r2.selected)("data-trackid", chip_r2.trackId ? chip_r2.trackId : null)("data-stb-chip", ctx_r2.rebrand);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.chipType === "input" && ctx_r2.rebrand && ctx_r2.iconName && ctx_r2.showPinIcon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.chipType === "filter");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 15, chip_r2.label));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.chipType === "input");
  }
}
let UnescapePipe = /*#__PURE__*/(() => {
  class UnescapePipe {
    transform(value, args) {
      return value.replace(/&shy;/g, '­'); // html entity '&shy;', '&#173;' aka. "soft hyphen"
    }
  }
  UnescapePipe.ɵfac = function UnescapePipe_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || UnescapePipe)();
  };
  UnescapePipe.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "unescape",
    type: UnescapePipe,
    pure: true
  });
  return UnescapePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChipComponent = /*#__PURE__*/(() => {
  class ChipComponent {
    constructor() {
      this.chipType = 'filter';
      this.rebrand = false;
      this.showPinIcon = true; // TODO: remove this, check if iconName is set or not instead
      this.iconName = 'pin';
      this.variant = 'default';
      this.chipClicked = new EventEmitter();
      this.options = [];
      this.touched = false;
      // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
      this.onChange = _options => {};
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      this.onTouched = () => {};
    }
    get chipTypeAttr() {
      return this.chipType;
    }
    ngOnInit() {
      if (this.containerWidth) {
        this.ref.nativeElement.style.width = this.containerWidth;
      }
    }
    writeValue(options) {
      this.options = options.map(option => {
        option.id = option.id || 'stbChip' + Math.random().toString(36).substring(2, 12);
        return option;
      });
    }
    registerOnChange(onChange) {
      this.onChange = onChange;
    }
    registerOnTouched(onTouched) {
      this.onTouched = onTouched;
    }
    markAsTouched() {
      if (!this.touched) {
        this.onTouched();
        this.touched = true;
      }
    }
    // This function is ripe for refactoring!
    // Because 'choice' behaves like radio-buttons, we need to mimic radio-button behavior
    chipKeydown(event, clickedChip) {
      const allowedKeys = ['Enter', ' ', 'ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'];
      if (!allowedKeys.includes(event.key)) {
        return;
      }
      event.preventDefault();
      if (event.key === 'Enter' || event.key === ' ') {
        this.chipClick(event, clickedChip);
        return;
      }
      let currentIndex = 0;
      let nextChip;
      const options = this.options.map((option, i) => {
        // clear all selected for choice (radio) chips
        if (this.chipType === 'choice') {
          option.selected = false;
        }
        if (option.value === clickedChip.value) {
          currentIndex = i;
        }
        return option;
      });
      switch (event.key) {
        case 'ArrowDown':
        case 'ArrowRight':
          if (currentIndex + 1 < this.options.length) {
            nextChip = this.getNextChipAndSelectForChoiceType(currentIndex + 1);
          } else {
            nextChip = this.getNextChipAndSelectForChoiceType(0);
          }
          break;
        case 'ArrowUp':
        case 'ArrowLeft':
          if (currentIndex > 0) {
            nextChip = this.getNextChipAndSelectForChoiceType(currentIndex - 1);
          } else {
            nextChip = this.getNextChipAndSelectForChoiceType(this.options.length - 1);
          }
          break;
        default:
          break;
      }
      // Set focus to next chip
      this.ref.nativeElement.querySelector(`#${nextChip.id}`).focus();
      // fire change event if choice variant
      if (this.chipType === 'choice') {
        this.registerChange(options, event, nextChip);
      }
    }
    chipClick(event, clickedChip) {
      const options = this.options.map(option => {
        if (this.chipType === 'choice') {
          option.selected = false;
        }
        if (option.value === clickedChip.value) {
          option.selected = !option.selected;
        }
        return option;
      });
      this.registerChange(options, event, clickedChip);
    }
    registerChange(options, event, selectedChip) {
      this.onChange(options);
      this.chipClicked.emit({
        event,
        chip: selectedChip
      });
      this.markAsTouched();
    }
    getNextChipAndSelectForChoiceType(index) {
      if (this.chipType === 'choice') {
        this.options[index].selected = true;
      }
      return this.options[index];
    }
  }
  ChipComponent.ɵfac = function ChipComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ChipComponent)();
  };
  ChipComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ChipComponent,
    selectors: [["stb-chip"]],
    viewQuery: function ChipComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 7);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ref = _t.first);
      }
    },
    hostVars: 1,
    hostBindings: function ChipComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("data-chip-type", ctx.chipTypeAttr);
      }
    },
    inputs: {
      chipType: "chipType",
      rebrand: "rebrand",
      showPinIcon: "showPinIcon",
      iconName: "iconName",
      variant: "variant",
      containerWidth: "containerWidth"
    },
    outputs: {
      chipClicked: "chipClicked"
    },
    features: [i0.ɵɵProvidersFeature([{
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ChipComponent),
      multi: true
    }])],
    decls: 3,
    vars: 10,
    consts: [["ref", ""], [1, "stb-chip-wrapper"], ["class", "stb-chip-element", 3, "ngClass", "chipBase", "chip", "keydown", "click", 4, "ngFor", "ngForOf"], [1, "stb-chip-element", 3, "keydown", "click", "ngClass"], ["aria-hidden", "true", "class", "icon input-icon", "translate", "no", 3, "icon-xsmall", "selected", "pin", "chipIcon", "iconLeft", 4, "ngIf"], ["aria-hidden", "true", "class", "icon filter-icon", "translate", "no", 3, "selected", "icon-xsmall", "chipIcon", "iconLeft", 4, "ngIf"], ["aria-hidden", "true", "class", "icon input-icon", "translate", "no", 3, "selected", "icon-xsmall", "chipIcon", "iconRight", 4, "ngIf"], ["aria-hidden", "true", "translate", "no", 1, "icon", "input-icon"], ["aria-hidden", "true", "translate", "no", 1, "icon", "filter-icon"]],
    template: function ChipComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 1, 0);
        i0.ɵɵtemplate(2, ChipComponent_div_2_Template, 7, 21, "div", 2);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵclassProp("rebrand", ctx.rebrand)("chipGroupBase", ctx.rebrand)("chipGroupStack", ctx.variant === "stack")("chipGroupScroll", ctx.variant === "scroll");
        i0.ɵɵattribute("data-stb-chip-group", ctx.rebrand);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.options);
      }
    },
    dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, UnescapePipe],
    styles: ["@font-face{font-family:SignaWeb-Book;src:url(https://assets.storebrand.no/fonts/Signa/SignaWeb-Book.woff) format(\"woff\");font-display:swap}@font-face{font-family:SignaWeb-Light;src:url(https://assets.storebrand.no/fonts/Signa/SignaWeb-Light.woff) format(\"woff\");font-display:swap}@font-face{font-family:Open Sans;font-style:normal;font-weight:400 700;font-variation-settings:\"wght\" 400 700;src:url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2 supports variations\"),url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2-variations\");font-display:swap}@font-face{font-family:Open Sans Semibold;font-style:normal;font-weight:600;font-variation-settings:\"wght\" 600;src:url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2 supports variations\"),url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2-variations\");font-display:swap}@font-face{font-family:Open Sans Bold;font-style:normal;font-weight:700;font-variation-settings:\"wght\" 700;src:url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2 supports variations\"),url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2-variations\");font-display:swap}@font-face{font-family:Storebrand Display;font-stretch:100%;font-style:normal;font-weight:400 700;font-display:swap;src:url(https://assets-t.storebrand.no/fonts/Storebrand/StorebrandDisplay.woff2) format(\"woff2\")}@font-face{font-family:Storebrand Text;font-style:normal;font-weight:400 700;font-stretch:100%;font-display:swap;src:url(https://assets-t.storebrand.no/fonts/Storebrand/StorebrandText.woff2) format(\"woff2\")}@font-face{font-family:System-Icons;src:url(https://assets.storebrand.no/fonts/System-Icons/System-Icons.eot) format(\"eot\"),url(https://assets.storebrand.no/fonts/System-Icons/System-Icons.woff) format(\"woff\"),url(https://assets.storebrand.no/fonts/System-Icons/System-Icons.woff2) format(\"wolf2\"),url(https://assets.storebrand.no/fonts/System-Icons/System-Icons.ttf) format(\"truetype\");text-rendering:optimizeLegibility}@font-face{font-family:Storebrand Symbols;src:url(https://assets.storebrand.no/fonts/Symbols/StorebrandSymbols.eot) format(\"eot\"),url(https://assets.storebrand.no/fonts/Symbols/StorebrandSymbols.woff) format(\"woff\"),url(https://assets.storebrand.no/fonts/Symbols/StorebrandSymbols.woff2) format(\"wolf2\"),url(https://assets.storebrand.no/fonts/Symbols/StorebrandSymbols.ttf) format(\"truetype\");text-rendering:optimizeLegibility}i.symbol[_ngcontent-%COMP%]{font-family:Storebrand Symbols!important}i[_ngcontent-%COMP%]{font-family:System-Icons!important;font-style:normal;font-weight:400!important;font-size:16px;line-height:16px;white-space:nowrap;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}i[_ngcontent-%COMP%]:empty:not([class*=system-icon]){display:inline-flex;width:24px;height:24px;background:var(--color-primary)}.icon-xsmall[_ngcontent-%COMP%]{font-size:16px!important;line-height:16px!important}.icon-small[_ngcontent-%COMP%]{font-size:20px!important;line-height:20px!important}.icon-medium[_ngcontent-%COMP%]{font-size:24px!important;line-height:24px!important}.icon-large[_ngcontent-%COMP%]{font-size:32px!important;line-height:32px!important}.sr-only[_ngcontent-%COMP%]{clip:rect(0 0 0 0);clip-path:inset(50%);height:1px;overflow:hidden;position:absolute;white-space:nowrap;width:1px}.stb-chip-wrapper[_ngcontent-%COMP%]:not(.rebrand){display:flex;flex-wrap:wrap;gap:8px}.stb-chip-wrapper[_ngcontent-%COMP%]:not(.rebrand)   .stb-chip-element[_ngcontent-%COMP%]{font-family:Open Sans,sans-serif;font-weight:400;font-size:16px;line-height:16px;height:32px;padding:0 16px;display:inline-flex;color:#191919;cursor:pointer;align-items:center;box-sizing:border-box;border-radius:16px;flex-shrink:0;border:2px solid #f5e4c7;transition-property:border,background-color,color;transition-duration:.1s;background-color:#fff}.stb-chip-wrapper[_ngcontent-%COMP%]:not(.rebrand)   .stb-chip-element[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{font-size:16px!important;display:none}.stb-chip-wrapper[_ngcontent-%COMP%]:not(.rebrand)   .stb-chip-element.selected[_ngcontent-%COMP%]{border:2px solid #5b462b;background:#5b462b none repeat scroll 0% 0%;-webkit-user-select:none;user-select:none;color:#fff}.stb-chip-wrapper[_ngcontent-%COMP%]:not(.rebrand)   .stb-chip-element.selected[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{display:inline-block;width:16px;height:16px}.stb-chip-wrapper[_ngcontent-%COMP%]:not(.rebrand)   .stb-chip-element.selected[_ngcontent-%COMP%]   .filter-icon[_ngcontent-%COMP%]{margin-right:8px;width:14px;height:20px;position:relative;top:1px}.stb-chip-wrapper[_ngcontent-%COMP%]:not(.rebrand)   .stb-chip-element.selected[_ngcontent-%COMP%]   .input-icon[_ngcontent-%COMP%]{margin-left:8px}.stb-chip-element[_ngcontent-%COMP%]:last-child{margin-right:0}.stb-chip-element[_ngcontent-%COMP%]:focus-visible{outline:2px solid #00f;outline-offset:4px;border-radius:999rem}", "[_nghost-%COMP%]   .chipGroupBase[data-stb-chip-group=true][_ngcontent-%COMP%]{font-family:Storebrand Text,sans-serif;display:flex;flex-wrap:wrap;gap:var(--p-spacing-rem-08)}[_nghost-%COMP%]   .chipGroupBase[data-stb-chip-group=true].chipGroupStack[_ngcontent-%COMP%]{flex-direction:column}[_nghost-%COMP%]   .chipGroupBase[data-stb-chip-group=true].chipGroupStack[_ngcontent-%COMP%]   .chipBase[_ngcontent-%COMP%]{width:-moz-fit-content;width:fit-content}[_nghost-%COMP%]   .chipGroupBase[data-stb-chip-group=true].chipGroupScroll[_ngcontent-%COMP%]{overflow-y:visible;scrollbar-width:none;flex-wrap:nowrap}[_nghost-%COMP%]   .chipGroupBase[data-stb-chip-group=true][_ngcontent-%COMP%] > .chipBase[data-stb-chip=true][_ngcontent-%COMP%]{--_chip-height: var(--chip-height, 40px);--_chip-color: var(--chip-color, var(--p-color-text-interactive));--_chip-background-color: var(--chip-background-color, transparent);--_chip-border-color: var(--chip-border-color, var(--p-color-stroke-subtle-0));--_chip-border: 1px solid var(--chip-border-color, var(--_chip-border-color));--_icon-size: var(--icon-size, 20px);--_font-size: var(--icon-size, 1.125rem);--_chip-transition-duration: var(--chip-transition-duration, var(--p-transition-duration, .1s));--_chip-vertical-padding: 5px;--chip-outline: none;color:var(--_chip-color);cursor:pointer;display:block;flex-shrink:0;min-height:var(--_chip-height);transition-duration:var(--_chip-transition-duration);transition-property:border,background-color,color,width;-webkit-user-select:none;user-select:none;font-size:var(--_font-size);line-height:calc(var(--_font-size) * .444rem)}[_nghost-%COMP%]   .chipGroupBase[data-stb-chip-group=true][_ngcontent-%COMP%] > .chipBase[data-stb-chip=true].chip[_ngcontent-%COMP%]{align-items:center;background-color:var(--_chip-background-color);border:var(--_chip-border);border-radius:var(--p-corner-radius-small);box-sizing:border-box;color:var(--_chip-color);display:inline-flex;min-height:var(--_chip-height);outline:var(--chip-outline);outline-offset:var(--p-outline-offset);padding:var(--_chip-vertical-padding) var(--p-spacing-rem-16);width:-moz-fit-content;width:fit-content}[_nghost-%COMP%]   .chipGroupBase[data-stb-chip-group=true][_ngcontent-%COMP%] > .chipBase[data-stb-chip=true].chip[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{overflow-wrap:anywhere;-webkit-hyphens:manual;hyphens:manual}[_nghost-%COMP%]   .chipGroupBase[data-stb-chip-group=true][_ngcontent-%COMP%] > .chipBase[data-stb-chip=true].chip[_ngcontent-%COMP%]:hover{--_chip-background-color: var(--p-color-surface-selected-hover);--_chip-border-color: var(--p-color-surface-selected-hover);--_chip-color: var(--p-color-text-on-color)}[_nghost-%COMP%]   .chipGroupBase[data-stb-chip-group=true][_ngcontent-%COMP%] > .chipBase[data-stb-chip=true].chip[_ngcontent-%COMP%]:active{--_chip-background-color: var(--p-color-surface-selected-pressed);--_chip-border-color: var(--p-color-surface-selected-pressed);--_chip-color: var(--p-color-text-on-color)}[_nghost-%COMP%]   .chipGroupBase[data-stb-chip-group=true][_ngcontent-%COMP%] > .chipBase[data-stb-chip=true].chip[_ngcontent-%COMP%]:focus-visible{--chip-outline: var(--p-outline)}[_nghost-%COMP%]   .chipGroupBase[data-stb-chip-group=true][_ngcontent-%COMP%] > .chipBase[data-stb-chip=true].chip.selected[_ngcontent-%COMP%]{--_chip-background-color: var(--p-color-surface-selected);--_chip-border-color: transparent;--_chip-color: var(--p-color-text-on-color)}[_nghost-%COMP%]   .chipGroupBase[data-stb-chip-group=true][_ngcontent-%COMP%] > .chipBase[data-stb-chip=true].chip.selected[_ngcontent-%COMP%]:hover{--_chip-background-color: var(--p-color-surface-selected-hover);--_chip-border-color: transparent;--_chip-color: var(--p-color-text-on-color)}[_nghost-%COMP%]   .chipGroupBase[data-stb-chip-group=true][_ngcontent-%COMP%] > .chipBase[data-stb-chip=true].chip.selected[_ngcontent-%COMP%]:active{--_chip-background-color: var(--p-color-surface-selected-pressed);--_chip-border-color: transparent;--_chip-color: var(--p-color-text-on-color)}[_nghost-%COMP%]   .chipGroupBase[data-stb-chip-group=true][_ngcontent-%COMP%] > .chipBase[data-stb-chip=true].chip.disabled[_ngcontent-%COMP%]{--_chip-background-color: var(--p-color-background-disabled);--_chip-border-color: var(--p-color-background-disabled);--_chip-color: var(--p-color-text-disabled);pointer-events:none}[_nghost-%COMP%]   .chipGroupBase[data-stb-chip-group=true][_ngcontent-%COMP%] > .chipBase[data-stb-chip=true].chip[_ngcontent-%COMP%]   i.icon[_ngcontent-%COMP%]{font-size:var(--_icon-size);line-height:var(--_icon-size)}[_nghost-%COMP%]   .chipGroupBase[data-stb-chip-group=true][_ngcontent-%COMP%] > .chipBase[data-stb-chip=true].chip[_ngcontent-%COMP%]   .icon.iconRight.selected[_ngcontent-%COMP%]{transition:opacity .1s .03s ease-out,width .15s 0s cubic-bezier(.175,.885,.32,1.275);width:var(--_icon-size);opacity:1}[_nghost-%COMP%]   .chipGroupBase[data-stb-chip-group=true][_ngcontent-%COMP%] > .chipBase[data-stb-chip=true].chip[_ngcontent-%COMP%]   .icon.iconRight[_ngcontent-%COMP%]{transition:opacity .1s ease-out,width .1s .05s ease-out;width:0;opacity:0}[_nghost-%COMP%]   .chipGroupBase[data-stb-chip-group=true][_ngcontent-%COMP%] > .chipBase[data-stb-chip=true].chip[_ngcontent-%COMP%]   .iconLeft[_ngcontent-%COMP%]{margin-right:var(--p-spacing-rem-08)}[_nghost-%COMP%]   .chipGroupBase[data-stb-chip-group=true][_ngcontent-%COMP%] > .chipBase[data-stb-chip=true].chip[_ngcontent-%COMP%]   .iconRight[_ngcontent-%COMP%]{margin-left:var(--p-spacing-rem-08)}@media (max-width: 600px){[_nghost-%COMP%]   .chipGroupBase[data-stb-chip-group=true][_ngcontent-%COMP%] > .chipBase[data-stb-chip=true][_ngcontent-%COMP%]{--_chip-height: 32px;--_font-size: 1rem;--_icon-size: 18px;--_chip-vertical-padding: 0px}}@media (min-width: 600px){[_nghost-%COMP%]   .chipGroupBase[data-stb-chip-group=true][_ngcontent-%COMP%] > .chipBase[data-stb-chip=true][_ngcontent-%COMP%]{--_chip-height: 40px;--_font-size: 1.125rem;--_icon-size: 20px}}@media (prefers-reduced-motion){[_nghost-%COMP%]   .chipGroupBase[data-stb-chip-group=true][_ngcontent-%COMP%] > .chipBase[data-stb-chip=true][_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{transition:none!important}}"]
  });
  return ChipComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChipModule = /*#__PURE__*/(() => {
  class ChipModule {}
  ChipModule.ɵfac = function ChipModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ChipModule)();
  };
  ChipModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: ChipModule
  });
  ChipModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule, HttpClientModule, ReactiveFormsModule]
  });
  return ChipModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of chip
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ChipComponent, ChipModule, UnescapePipe };
